import React, { } from "react";
import { Button, Input, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useWorkshopQueryModel } from "../workshopQueryModel";
import { DetailType } from "@/types/ScmEnums";
import useGlobalModel from "@/model/globalModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { momentFormats } from "@/utils/utils";
import moment from "moment";
export const DataBox = () => {
    const { selectedRow, selectedRowKeys, setDispatchVisible, setDetailType, finished } = useWorkshopQueryModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "4-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            {
                id: selectedRow.maintenanceCode as string, mode: "look", parentInfo: { selectedNavId }
            },
            true
        );
    }

    const onFinished = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status !== 'maintenance.underway') {
            globalPrompt("message", { text: "请选择在修数据完工！", type: "warning" });
            return;
        }
        let newTime = momentFormats(selectedRow.expectedCompletionTime);

        // 获取当前时间
        const currentTime = moment(); // 假设moment已在项目中引入
        const expectedTime = moment(newTime);

        // 判断是否超时
        const isTimeout = selectedRow.expectedCompletionTime ? currentTime.isAfter(expectedTime) : false;

        let timeoutCompleteReason = "";

        const createBaseModalConfig: any = (includeReasonInput = false) => {
            return {
                title: "工单完工",
                type: "success",
                text: includeReasonInput ? (
                    <>
                        <span>当前时间已超过预计完工时间，请输入超时完工原因</span>
                        <Input onChange={(e) => { timeoutCompleteReason = e.target.value }} />
                    </>
                ) : "",
                okText: "确定",
                onOk: () => {
                    if (includeReasonInput && !timeoutCompleteReason) {
                        message.error("请输入超时完工原因！");
                        return;
                    }

                    let obj: any = {
                        id: selectedRow.id,
                        maintenanceCode: selectedRow.maintenanceCode,
                    };

                    if (includeReasonInput) {
                        obj.timeoutCompleteReason = timeoutCompleteReason;
                    }

                    finished(obj).then(res => {
                        globalPrompt("message", { text: "订单完工", type: "success" });
                    });
                },
                cancelText: "取消",
                onCancel: () => { },
            };
        };
        // 根据是否超时显示不同的模态框
        if (isTimeout) {
            globalPrompt("modal", createBaseModalConfig(true));
        } else {
            globalPrompt("modal", createBaseModalConfig(false));
        }
    };
    const onDispatch = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }

        setDispatchVisible(true)
        setDetailType(DetailType.edit)
    }
    const onDispatchLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setDispatchVisible(true)
        setDetailType(DetailType.look)

    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DISP_LIST_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DISP_LIST_DISP}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onDispatch}
            >派工</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DISP_LIST_FINISH}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onFinished}
            >完工</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.DISP_LIST_VW_M}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onDispatchLook}
            >维修工查看</Button>
        </YhAuth> */}
    </>;

    return (
        // <YhBox title="派工列表" action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}